document.addEventListener("DOMContentLoaded", function () {
  var swiperAboutV3 = new Swiper(".aboutus__v3--imagesslider", {
    slidesPerView: 1,
    spaceBetween: 0,
    scrollbar: {
      el: ".swiper-scrollbar.aboutus-v3",
      draggable: true
    },
    navigation: {
      nextEl: ".swiper-button-next.aboutus-v3",
      prevEl: ".swiper-button-prev.aboutus-v3"
    }
  });
});
